import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

const initialUserState = {
  userInfo: {},
};

export const useUserStore = create(
  persist(
    (set) => ({
      ...initialUserState,
      updateUserInfo: (user) => set({ userInfo: user }),
      reset: () => set({ ...initialUserState }),
    }),
    {
      name: "superfinanciera-user",
      storage: createJSONStorage(() => localStorage),
    },
  ),
);
